export const customerSettings = {
COMPANY_CODE: "demostore",
MODE: "production",
ENV: "production",
VERSION: 1.1,
DOMAIN: 'demostore.be',
SCRIPTS: [{'src': 'https://plugin.digex.be/plugin/demo/94f326cb-489d-4ecd-8ad0-2d91d6124662/main/latest/plugin.js', 'type': 'module', 'id': 'digex-plugin-webcomponents', 'fetchpriority': 'high'}],
FONTS: [{'rel': 'modulepreload', 'href': 'https://plugin.digex.be/plugin/demo/94f326cb-489d-4ecd-8ad0-2d91d6124662/main/latest/plugin.js', 'as': 'script'}],
SENTRY_DSN: "",
LANGUAGES: ['nl', 'fr'],
FORCE_SINGLE_LANGUAGE_IN_URL: false,
WEBSITE_NAME: "",
IMAGE_PROMO_POSITION: "",
PATH_PREFIX: "",

GOOGLE_ANALYTICS_IDENTIFICATION: '',
GOOGLE_ANALYTICS_ID: '',
GOOGLE_TAG_MANAGER_ID: '',
MAPBOX_TOKEN: 'pk.eyJ1IjoiYXV0cmFsaXMiLCJhIjoiY2toeXR2emhwMDk0OTJ6cWh0Y3JjeG5kaSJ9.YCvAWa5Wyqof0wPdueve5w',
RECAPTCHA_KEY: '6LcZyaUZAAAAAOrMBxDUfdVDq2xKcHORceibmov3',
FINANCING: false,
FINANCING_SETTINGA: 'Example',
FINANCING_TEXT: false,
RESERVATION: false,
FAVORITES: false,
VEHICLE_COMPARE: false,
SEO: false,
ACCOUNT: false
};